export const BusinessProcessConstants = {
  Prepare: 'Prepare',
  Assessment: 'Assessment',
  Implementation: 'Implementation',
  Completed: 'Completed',
};
